import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import { cloneDeep, set, round } from 'lodash';
import Select from 'react-select';
import { Col, Container, Row, Modal } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import { checkArray, specNumberRegex } from '../../../Components/helper';
import * as action from './Store/SpecTemplate.action';
import { getProductGrading } from '../../DevlopmentOrder/store/DevelopmentOrder.action';
import './SpecTemplate.css';
import ImgDropzone from '../../../Components/ImgDropzone/ImgDropzone';
import Loader from '../../../Components/Utility/Loader/Loader';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import GradingDetail from './Component/GradingDetail';
import POMTable from './Component/POMTable';
import SpecImage from './Component/SpecImage';
import SupportingDocument from './Component/SupportingDocument';
import { calculatePreviousSize, calculationSampleSize } from '../../DevlopmentOrder/Measurment/Components/Calculation';
import { getCatBasedOnPT } from '../../SystemMasters/Store/SystemMasters.action';
import DragDrogRearrange from '../../../Components/DragDrogRearrange/DragDrogRearrange';
import { calculateSpecMeasurements } from './specTemplateCalc';

function AddEditSpecTemplate() {
  const { specTemplateId } = useParams();
  const {
    Users: { logInRights },
    SpecTemplateData: { AllGradingList, SpecDetails },
    UserDetails: { userInfo },
  } = useSelector((reduxState) => reduxState);
  const { gradingFormat } = userInfo;

  const { t } = useTranslation('common');
  const { CheckActionPermission } = useComponent();
  const [state, setState] = useState({
    isPageDisable: false,
    specTemplateData: {},
    isEditMode: false,
    showImageUpload: false,
    showDeleteModal: false,
    showConfirmImport: false,
    pomLibraryOptions: [],
    isPageLoad: false,
    isGradingChange: false,
    errorLog: [],
    noPOMFound: false,
    selectedIdArray: [],
    clonedSpecData: {},
    loading: false,
    showRearrangeModal: false,
  });
  const history = useHistory();
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  const loggedInUserId = userInfo?.userId;
  const {
    isPageDisable,
    specTemplateData,
    isEditMode,
    showImageUpload,
    showDeleteModal,
    showConfirmImport,
    pomLibraryOptions,
    isPageLoad,
    isGradingChange,
    errorLog,
    noPOMFound,
    selectedIdArray,
    clonedSpecData,
    showRearrangeModal,
  } = state;
  const dispatch = useDispatch();
  const SpecAddEditAccess = CheckActionPermission(logInRights, 'libraries', 'spec', 'addEdit');
  const SpecDeleteAccess = CheckActionPermission(logInRights, 'libraries', 'spec', 'delete');
  let specTempGradingLib = specTemplateData?.selectedGradingLib;
  const childRef = useRef();
  const typeaheadPOM = useRef(null);
  useEffect(() => {
    const Init = async () => {
      await dispatch(action.fetchAllGrading({ loggedInUserId, pomLibraries: true }));
    };
    Init();
    return () => {
      dispatch(action.unmountSpecTemplate());
      setState((prevState) => ({
        ...prevState,
        isEditMode: false,
        specTemplateData: {},
        clonedSpecData: {},
      }));
    };
  }, []);

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  useEffect(() => {
    const getSpecDetail = async () => {
      if (specTemplateId) {
        setState((prevState) => ({
          ...prevState,
          isPageLoad: true,
        }));
        const specObj = {
          specTemplateId,
          fromDetails: true,
        };
        await dispatch(action.fetchSpecTemplate(specObj));
        setState((prevState) => ({
          ...prevState,
          isEditMode: true,
          isPageDisable: true,
          isPageLoad: false,
          isGradingChange: true,
        }));
      }
    };
    getSpecDetail();
  }, [dispatch, specTemplateId]);

  useEffect(() => {
    const callFn = async () => {
      if (SpecDetails) {
        const getCalculatedSpec = calculateSpecMeasurements(SpecDetails?.pomLibraries || [], gradingFormat);

        const getProductTypeIds =
          Array.isArray(SpecDetails?.productTypeId) && SpecDetails.productTypeId.length > 0
            ? SpecDetails.productTypeId
            : (SpecDetails?.selectedGradingLib?.productTypeId || []).map((pt) => pt?._id);

        const gradingGroupId = SpecDetails?.selectedGradingLib?._id;
        const selectedGradingFromList = AllGradingList?.find((grading) => grading._id === gradingGroupId);
        const gradingPomLibraries = selectedGradingFromList?.pomLibraries || [];
        const filteredSizeRanges = JSON.parse(SpecDetails?.sizeRanges || '[]');
        const modifiedSizeRanges = filteredSizeRanges.find((item) => item.isSampleSize);

        const sizeRangesArray = SpecDetails?.selectedGradingLib?.sizeRanges || [];
        const updatedSizeRanges = Array.isArray(sizeRangesArray)
          ? sizeRangesArray.map((item) => ({
              ...item,
              isSampleSize: modifiedSizeRanges?.name ? item.name === modifiedSizeRanges.name : false,
            }))
          : [];
        if (specTempGradingLib) {
          specTempGradingLib.sizeRanges = updatedSizeRanges;
        } else {
          specTempGradingLib = SpecDetails?.selectedGradingLib;
          specTempGradingLib.sizeRanges = updatedSizeRanges;
        }
        setState((prevState) => ({
          ...prevState,
          specTemplateData: {
            ...SpecDetails,
            pomLibraries: getCalculatedSpec,
            selectedBrand: SpecDetails?.brandId,
            selectedSubBrand: SpecDetails?.subBrandId,
            selectedCatOne: SpecDetails?.catOneId,
            selectedCatTwo: SpecDetails?.catTwoId,
            selectedCatThre: SpecDetails?.catThreeId,
            selectedSizeRanges: updatedSizeRanges,
            sizeRanges: checkArray(updatedSizeRanges) ? JSON.stringify(updatedSizeRanges) : [],
            productTypeId: getProductTypeIds,
          },
          clonedSpecData: {
            ...SpecDetails,
            pomLibraries: getCalculatedSpec,
            selectedBrand: SpecDetails?.brandId,
            selectedSubBrand: SpecDetails?.subBrandId,
            selectedCatOne: SpecDetails?.catOneId,
            selectedCatTwo: SpecDetails?.catTwoId,
            selectedCatThre: SpecDetails?.catThreeId,
            selectedSizeRanges: updatedSizeRanges,
            sizeRanges: checkArray(updatedSizeRanges) ? JSON.stringify(updatedSizeRanges) : [],
            productTypeId: getProductTypeIds,
          },
          pomLibraryOptions: gradingPomLibraries,
        }));
      }
    };

    callFn();
  }, [SpecDetails, AllGradingList]);

  const getSelectValue = (mainArray, itemId) => {
    return checkArray(mainArray) ? mainArray.find((ele) => ele?._id === itemId) : null;
  };
  const handleImageUpload = () => {
    setState((prevState) => ({
      ...prevState,
      showImageUpload: true,
    }));
  };
  const handleImageDelete = () => {
    setState((prevState) => ({
      ...prevState,
      showDeleteModal: true,
    }));
  };
  const closeModal = () => {
    setState((prevState) => ({
      ...prevState,
      showDeleteModal: false,
    }));
  };
  const closeConfirmImportModal = () => {
    const cloneData = cloneDeep(specTemplateData);
    cloneData.pomLibraries = [];
    setState((prevState) => ({
      ...prevState,
      showConfirmImport: false,
      specTemplateData: cloneData,
      clonedSpecData: cloneData,
    }));
  };
  const confirmImportPom = () => {
    const cloneData = cloneDeep(specTemplateData);
    const allSizeRanges = specTempGradingLib?.sizeRanges || [];
    cloneData.pomLibraries = pomLibraryOptions.map((pom) => fillMissingGradings(pom, allSizeRanges));
    setState((prevState) => ({
      ...prevState,
      showConfirmImport: false,
      specTemplateData: cloneData,
      clonedSpecData: cloneData,
    }));
  };
  const confirmDeleteImage = () => {
    const copyState = cloneDeep(specTemplateData);
    set(copyState, 'image', '');
    set(copyState, 'fullImage', '');

    setState((prevData) => ({
      ...prevData,
      specTemplateData: copyState,
      showDeleteModal: false,
    }));
  };
  const handleSubmitUpload = async (type) => {
    if (type !== 'close') {
      const croppedFileUrl = await childRef.current.showCroppedImg();

      if (croppedFileUrl) {
        const { imageRes, originalImg } = await croppedFileUrl;
        const orignalImageres = await originalImg;
        const copyState = cloneDeep(specTemplateData);
        set(copyState, 'image', imageRes);
        set(copyState, 'fullImage', orignalImageres);
        setState((prevData) => ({
          ...prevData,
          showImageUpload: false,
          specTemplateData: copyState,
        }));
      } else {
        toasterMsg(t('SPEC_TEMP_LIBRARY.IMAGE_REQUIRED'), 'danger');
      }
    } else {
      setState((prevData) => ({
        ...prevData,
        showImageUpload: false,
      }));
    }
  };
  const handleActiveInactive = (value, key) => {
    const copyState = cloneDeep(specTemplateData);
    set(copyState, key, value);
    setState((prevData) => ({
      ...prevData,
      specTemplateData: copyState,
    }));
  };

  const setFirstOption = (options) => {
    return options?.length === 1 ? options[0]?._id : '';
  };
  const handleGradingChange = async (gradingData) => {
    try {
      if (gradingData !== null) {
        const response = await dispatch(action.fetchGradingById({ loggedInUserId }, gradingData?._id));
        const selectedGradingLib = response?.data || {};
        const hasPomLibraries = Array.isArray(selectedGradingLib.pomLibraries) && selectedGradingLib.pomLibraries.length > 0;

        setState((prevData) => ({
          ...prevData,
          noPOMFound: false,
          isGradingChange: true,
          showConfirmImport: hasPomLibraries,
          pomLibraryOptions: hasPomLibraries ? selectedGradingLib.pomLibraries : [],
          errorLog: errorLog.filter((item) => item !== 'grading'),
          specTemplateData: {
            ...cloneDeep(specTemplateData),
            selectedGradingLib: {
              ...selectedGradingLib,
              brand: gradingData?.brand || [],
              subBrand: gradingData?.subBrandId || [],
              catThree: gradingData?.catThree || [],
            },
            productTypeId: gradingData?.productTypeId.map((item) => item?._id) || [],
            catThreeId: setFirstOption(gradingData?.catThree),
            brandId: setFirstOption(gradingData?.brand),
            subBrandId: setFirstOption(gradingData?.subBrand),
            pomLibraries: hasPomLibraries ? [] : null,
            selectedBrand: setFirstOption(gradingData?.brand),
            selectedSubBrand: setFirstOption(gradingData?.subBrand),
            selectedCatThre: setFirstOption(gradingData?.catThree),
            selectedCatOne: gradingData?.catsOneIds,
            selectedCatTwo: gradingData?.catsTwoIds,
            selectedSizeRanges: gradingData?.sizeRanges,
            sizeRanges: checkArray(gradingData?.sizeRanges) ? JSON.stringify(gradingData?.sizeRanges) : [],
          },
        }));

        if (!hasPomLibraries) {
          toasterMsg(t('SPEC_TEMP_LIBRARY.NO_POM_MESSAGE'), 'danger');
          setState((prevData) => ({
            ...prevData,
            noPOMFound: true,
          }));
        }
      } else {
        setState((prevData) => ({
          ...prevData,
          isGradingChange: false,
          pomLibraryOptions: [],
          specTemplateData: {
            ...cloneDeep(specTemplateData),
            selectedGradingLib: { _id: '' },
            catThreeId: '',
            brandId: '',
            subBrandId: '',
            pomLibraries: [],
            selectedBrand: '',
            selectedSubBrand: '',
            selectedCatThre: '',
            selectedCatOne: [],
            selectedCatTwo: [],
            selectedSizeRanges: [],
            sizeRanges: [],
          },
        }));
      }
    } catch (error) {
      console.error('Error in handleGradingChange:', error);
    }
  };

  const fillMissingGradings = (pomItem, allSizeRanges) => {
    if (!pomItem?.gradings || !Array.isArray(pomItem.gradings) || !Array.isArray(allSizeRanges)) {
      return pomItem;
    }
    const clonedItem = cloneDeep(pomItem);
    const existingSizeNames = new Set(clonedItem.gradings.map((g) => g?.sizeName));
    const missingSizes = allSizeRanges.filter((sr) => !existingSizeNames.has(sr?.name));
    if (missingSizes.length === 0) return clonedItem;
    const newGradings = missingSizes.map((sr) => ({
      sizeName: sr?.name,
      grading: '0',
      measurment: '0',
      isSampleSize: false,
      isZero: false,
    }));
    clonedItem.gradings = [...clonedItem.gradings, ...newGradings];
    return clonedItem;
  };

  const swapSampleSizeValues = (pomItem, currentSampleSizeName, newSampleSizeName) => {
    if (!pomItem?.gradings || !Array.isArray(pomItem.gradings)) {
      return pomItem;
    }

    const clonedItem = cloneDeep(pomItem);
    const currentSampleGrading = clonedItem.gradings.find(
      (grad) => grad.sizeName === currentSampleSizeName && (grad.isZero === true || grad.isSampleSize === true),
    );
    const newSampleGrading = clonedItem.gradings.find((grad) => grad.sizeName === newSampleSizeName);

    if (currentSampleGrading && newSampleGrading) {
      const currentGradingValue = currentSampleGrading.grading;
      const newGradingValue = newSampleGrading.grading;

      currentSampleGrading.grading = newGradingValue;
      currentSampleGrading.isZero = false;
      currentSampleGrading.isSampleSize = false;

      newSampleGrading.grading = currentGradingValue;
      newSampleGrading.isZero = true;
      newSampleGrading.isSampleSize = true;
    } else if (newSampleGrading) {
      const currentGradingValue = currentSampleGrading?.grading || '0';
      if (currentSampleGrading) {
        currentSampleGrading.isZero = false;
        currentSampleGrading.isSampleSize = false;
      }
      newSampleGrading.grading = currentGradingValue;
      newSampleGrading.isZero = true;
      newSampleGrading.isSampleSize = true;
    }

    return clonedItem;
  };

  const handleImportPomGrading = async () => {
    if (specTemplateData?.selectedGradingLib?._id) {
      const response = await dispatch(action.fetchGradingById({ loggedInUserId }, specTemplateData?.selectedGradingLib?._id));
      const selectedGradingLib = response?.data || {};

      if (selectedGradingLib?.pomLibraries?.length !== specTemplateData?.pomLibraries?.length) {
        const cloneData = cloneDeep(specTemplateData);
        const importedPomLibraries = selectedGradingLib.pomLibraries || [];

        const currentSizeRanges = Array.isArray(specTemplateData.sizeRanges) ? specTemplateData.sizeRanges : JSON.parse(specTemplateData?.sizeRanges || '[]');
        const currentSampleSize = currentSizeRanges.find((item) => item.isSampleSize);
        const currentSampleSizeName = currentSampleSize?.name;

        if (importedPomLibraries.length > 0) {
          const firstImportedPom = importedPomLibraries[0];
          const importedSampleGrading = firstImportedPom?.gradings?.find((grad) => grad.isSampleSize === true || grad.isZero === true);
          const importedSampleSizeName = importedSampleGrading?.sizeName;

          const allSizeRanges = selectedGradingLib?.sizeRanges || specTempGradingLib?.sizeRanges || [];
          if (currentSampleSizeName && importedSampleSizeName && currentSampleSizeName !== importedSampleSizeName) {
            const updatedImportedPomLibraries = importedPomLibraries.map((pomItem) =>
              swapSampleSizeValues(fillMissingGradings(pomItem, allSizeRanges), importedSampleSizeName, currentSampleSizeName),
            );

            const calculatedPomLibraries = calculateSpecMeasurements(updatedImportedPomLibraries, gradingFormat);
            cloneData.pomLibraries = calculatedPomLibraries;
          } else {
            const calculatedPomLibraries = calculateSpecMeasurements(
              importedPomLibraries.map((pom) => fillMissingGradings(pom, allSizeRanges)),
              gradingFormat,
            );
            cloneData.pomLibraries = calculatedPomLibraries;
          }
        } else {
          const allSizeRanges = selectedGradingLib?.sizeRanges || specTempGradingLib?.sizeRanges || [];
          const calculatedPomLibraries = calculateSpecMeasurements(
            (selectedGradingLib.pomLibraries || []).map((pom) => fillMissingGradings(pom, allSizeRanges)),
            gradingFormat,
          );
          cloneData.pomLibraries = calculatedPomLibraries;
        }

        setState((prevState) => ({
          ...prevState,
          specTemplateData: cloneData,
        }));
      } else {
        toasterMsg(t('SPEC_TEMP_LIBRARY.POM_ALREADY_ADDED'), 'danger');
      }
    } else {
      toasterMsg(t('SPEC_TEMP_LIBRARY.GRADING_REQUIRED'), 'danger');
    }
  };
  const handleInputSelect = (value, key) => {
    const cloneData = cloneDeep(specTemplateData);
    const selectedValue = typeof value === 'object' ? value?._id : value;
    cloneData[key] = selectedValue;

    if (key === 'brandId') {
      cloneData.selectedBrand = selectedValue || null;
      cloneData.subBrandId = null;
      cloneData.selectedSubBrand = null;

      // Get the original subbrand data from the grading library, not from the current filtered state
      const originalSubBrands = cloneData?.selectedGradingLib?.originalSubBrand || cloneData?.selectedGradingLib?.subBrand || [];

      // Store original subbrand data if not already stored
      if (!cloneData?.selectedGradingLib?.originalSubBrand) {
        cloneData.selectedGradingLib = {
          ...cloneData.selectedGradingLib,
          originalSubBrand: [...originalSubBrands],
        };
      }

      // Filter subbrands based on selected brand, or show all if no brand selected
      const filteredSubBrands = selectedValue ? originalSubBrands?.filter((sb) => sb?.brandId === selectedValue) || [] : originalSubBrands || [];

      cloneData.selectedGradingLib = {
        ...cloneData.selectedGradingLib,
        subBrand: [...filteredSubBrands],
      };
    }
    if (key === 'subBrandId') {
      cloneData.selectedSubBrand = selectedValue || null;
    }

    if (key === 'catThreeId') {
      cloneData.selectedCatThre = selectedValue || null;
    }

    setState((prevState) => ({
      ...prevState,
      specTemplateData: cloneData,
    }));
  };

  const handleInputBlur = (value, key) => {
    let errorLogKeyList = [];
    if (key === 'code' && value.trim() !== '') {
      errorLogKeyList = errorLog.filter((item) => item !== 'code');
    }
    const cloneData = cloneDeep(specTemplateData);
    cloneData[key] = value.trim();
    setState((prevState) => ({
      ...prevState,
      specTemplateData: cloneData,
      errorLog: errorLogKeyList,
    }));
  };

  const isImageBase64 = specTemplateData?.fullImage?.includes('data:image/');
  const isValid = () => {
    const errorLogKey = [];

    if (!Object.hasOwnProperty.call(specTemplateData, 'code') || specTemplateData.code.trim() === '') {
      errorLogKey.push('code');
    }
    if (!Object.hasOwnProperty.call(specTemplateData, 'selectedGradingLib') || specTemplateData.selectedGradingLib?._id?.trim() === '') {
      errorLogKey.push('grading');
    }

    setState((prevState) => ({
      ...prevState,
      errorLog: errorLogKey,
    }));
    return errorLogKey.length <= 0;
  };
  const saveSpecTemplate = async () => {
    if (isValid()) {
      setState((prevState) => ({
        ...prevState,
        loading: true,
      }));
      const updatedData = {
        ...specTemplateData,
        pomLibraries: JSON.stringify(specTemplateData.pomLibraries),
        selectedGradingLib: specTemplateData?.selectedGradingLib?._id,
        section: 'libraries',
        module: 'spec',
        action: 'addEdit',
      };
      if (!catBasedOnPTData) {
        delete updatedData.productTypeId;
      }

      if (isEditMode) {
        const updateResponse = await dispatch(action.updateSpecDetail(specTemplateId, updatedData, t));
        setState((prevState) => ({
          ...prevState,
          loading: false,
        }));
        if (updateResponse.code === 200) {
          setState((prevState) => ({
            ...prevState,
            isPageDisable: true,
          }));
        }
      } else {
        const saveResponse = await dispatch(action.addSpecDetail(updatedData, t));
        setState((prevState) => ({
          ...prevState,
          loading: false,
        }));
        if (saveResponse.code === 200) {
          const insertedId = saveResponse?.data?.insertedId[0];
          history.push(`/libraries/spec-template/edit/${insertedId}`);
        }
      }
    }
  };

  const handleEditPage = () => {
    setState((prevState) => ({
      ...prevState,
      isPageDisable: false,
    }));
  };
  const checkPOMNOtExist = (addedPOM) => {
    if (addedPOM?.length) {
      const isPomFound = specTemplateData?.pomLibraries?.filter((eleSpecPOM) => eleSpecPOM.code === addedPOM[0]?.code);

      if (isPomFound?.length > 0) {
        toasterMsg(t('SPEC_TEMP_LIBRARY.POM_ALREADY_ADDED'), 'danger');
      }
      return isPomFound.length === 0;
    }
  };

  const onAutoSuggestion = async (selected) => {
    const typeaheadConfigRef1 = typeaheadPOM.current;
    if (selected?.length && checkPOMNOtExist(selected)) {
      const specDataCopy = cloneDeep(specTemplateData);
      const rawImportedItem = selected[0];
      const allSizeRanges = specTempGradingLib?.sizeRanges || [];
      const importedItem = fillMissingGradings(rawImportedItem, allSizeRanges);

      const currentSizeRanges = Array.isArray(specTemplateData.sizeRanges) ? specTemplateData.sizeRanges : JSON.parse(specTemplateData?.sizeRanges || '[]');
      const currentSampleSize = currentSizeRanges.find((item) => item.isSampleSize);
      const currentSampleSizeName = currentSampleSize?.name;

      const importedSampleGrading = importedItem?.gradings?.find((grad) => grad.isSampleSize === true || grad.isZero === true);
      const importedSampleSizeName = importedSampleGrading?.sizeName;

      if (currentSampleSizeName && importedSampleSizeName && currentSampleSizeName !== importedSampleSizeName) {
        const updatedItem = swapSampleSizeValues(importedItem, currentSampleSizeName, importedSampleSizeName);

        const updatedSizeRanges = currentSizeRanges.map((item) => ({
          ...item,
          isSampleSize: item.name === importedSampleSizeName,
          isZero: item.name === importedSampleSizeName,
        }));

        let updatedPomLibraries = specDataCopy.pomLibraries || [];
        if (updatedPomLibraries.length > 0) {
          updatedPomLibraries = updatedPomLibraries.map((pomItem) => swapSampleSizeValues(pomItem, currentSampleSizeName, importedSampleSizeName));
        }

        specDataCopy.sizeRanges = Array.isArray(updatedSizeRanges) ? JSON.stringify(updatedSizeRanges) : updatedSizeRanges;
        specDataCopy.pomLibraries = [...updatedPomLibraries, updatedItem];

        if (specTempGradingLib) {
          specTempGradingLib.sizeRanges = updatedSizeRanges;
          specTempGradingLib.sampleSize = importedSampleSizeName;
        }
      } else {
        specDataCopy.pomLibraries = [...specDataCopy.pomLibraries, importedItem];
      }

      setState((prevState) => ({
        ...prevState,
        specTemplateData: specDataCopy,
      }));
    }

    if (typeaheadConfigRef1) typeaheadConfigRef1.clear();
  };
  const filterByLibrary = (option, props) => {
    const code = option?.code ? option?.code?.toLowerCase() : '';
    const des = option?.description ? option?.description?.toLowerCase() : '';
    const search = props.text.trim().toLowerCase();
    return code.includes(search) || des.includes(search);
  };

  const handlePOMInput = (value, key, sizeName, rowIndex) => {
    if (specNumberRegex.test(value) || value === '') {
      const specDataClone = cloneDeep(specTemplateData);
      const rowData = specDataClone.pomLibraries[rowIndex];
      const cloneGRading = rowData?.gradings?.filter((vl) => vl) || [];
      let gradSizeData = cloneGRading?.find((o) => o.sizeName === sizeName);
      if (!gradSizeData) {
        gradSizeData = { sizeName, grading: '0', measurment: '0', isSampleSize: false, isZero: false };
        cloneGRading.push(gradSizeData);
        rowData.gradings = cloneGRading;
      }
      const cIndex = cloneGRading?.indexOf(gradSizeData);
      gradSizeData[key] = value;
      rowData.gradings[cIndex] = gradSizeData;
      specDataClone.pomLibraries[rowIndex] = rowData;
      setState((prev) => ({
        ...prev,
        specTemplateData: specDataClone,
      }));
    }
  };

  const handleTolIinput = (value, key, rowIndex) => {
    if (specNumberRegex.test(value) || value === '') {
      const specDataClone = cloneDeep(specTemplateData);
      specDataClone.pomLibraries[rowIndex][key] = value;
      specDataClone.pomLibraries[rowIndex].tolPlus = value;

      setState((prev) => ({
        ...prev,
        specTemplateData: specDataClone,
      }));
    }
  };

  const deleteSinglePOM = (specCodeOrId) => {
    const specDataClone = cloneDeep(specTemplateData);

    // If specCodeOrId is an array, treat it as an array of spec codes
    if (Array.isArray(specCodeOrId)) {
      specCodeOrId.forEach((code) => {
        specDataClone.pomLibraries = specDataClone?.pomLibraries.filter((item) => item.code !== code);
      });
    } else {
      // If specCodeOrId is a single spec code
      const code = specCodeOrId; // Assuming specCodeOrId is the spec code
      specDataClone.pomLibraries = specDataClone?.pomLibraries.filter((item) => item.code !== code);
    }
    setState((prev) => ({
      ...prev,
      specTemplateData: specDataClone,
      selectedIdArray: [],
    }));
  };

  const toggleRearrangeModal = (open) => setState((prev) => ({ ...prev, showRearrangeModal: Boolean(open) }));

  const rearrangeItems = useMemo(
    () =>
      (specTemplateData?.pomLibraries || []).map((pom) => ({
        _id: pom?._id ? String(pom._id) : pom?.code,
        label: pom?.code,
        description: pom?.description,
      })),
    [specTemplateData?.pomLibraries],
  );

  // BM-7946: persist the rearranged sequence via the dedicated API, then
  // reflect the new order (and sequence numbers) in local state so the POM
  // table re-renders immediately.
  const handleSaveRearrangeSequence = async ({ sequence }) => {
    if (!specTemplateId || !Array.isArray(sequence) || sequence.length === 0) {
      return;
    }
    const response = await dispatch(action.updateSpecTemplatePomSequence(specTemplateId, { sequence }, t));
    if (response?.code !== 200) {
      return;
    }
    const sequenceByKey = new Map(sequence.map((entry) => [String(entry._id), entry.sequence]));
    const keyFor = (pom) => String(pom?._id ?? pom?.code ?? '');
    const reordered = [...(specTemplateData?.pomLibraries || [])]
      .map((pom) => {
        const nextSequence = sequenceByKey.get(keyFor(pom));
        return typeof nextSequence === 'number' ? { ...pom, sequence: nextSequence } : pom;
      })
      .sort((a, b) => (a?.sequence ?? Number.MAX_SAFE_INTEGER) - (b?.sequence ?? Number.MAX_SAFE_INTEGER));
    setState((prev) => ({
      ...prev,
      specTemplateData: { ...prev.specTemplateData, pomLibraries: reordered },
      showRearrangeModal: false,
    }));
  };

  const handleCheckALl = (e) => {
    if (e.target.checked) {
      const selectedItems = specTemplateData?.pomLibraries?.map((item) => item.code);
      setState((prev) => ({
        ...prev,
        selectedIdArray: selectedItems,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        selectedIdArray: [],
      }));
    }
  };

  const onSelectCheckBox = async (id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (findItems.length > 0) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setState((prev) => ({
        ...prev,
        selectedIdArray: [...selectedItems],
      }));
    } else {
      setState((prev) => ({
        ...prev,
        selectedIdArray: [...selectedItems, id],
      }));
    }
  };

  const calculateMeasurement = async (rowIndex) => {
    const specDataClone = cloneDeep(clonedSpecData);
    const mainArray = specTemplateData;
    const sampleData = mainArray?.pomLibraries[rowIndex];
    const orgSpecData = specDataClone?.pomLibraries[rowIndex];
    if (!sampleData) return;

    if (gradingFormat === 'sample') {
      const finalSampleData = await calculationSampleSize(sampleData, orgSpecData);
      mainArray.pomLibraries[rowIndex] = finalSampleData;
    } else {
      calculatePreviousSize(sampleData, orgSpecData);
      mainArray.pomLibraries[rowIndex] = sampleData;
    }
    setState((prev) => ({
      ...prev,
      specTemplateData: mainArray,
    }));
  };

  const getMergedTitleRow = () => {
    const sizeRanges = JSON.parse(specTemplateData?.sizeRanges);
    const dynamicColumnsLength = sizeRanges?.length; // Assuming getHeaderRow() returns an array of arrays
    const mergedTitleRow = Array.from({ length: dynamicColumnsLength }, () => ({ value: 'Your Title' }));
    return [mergedTitleRow[0]];
  };

  // Function to get header row for Excel sheet
  const getHeaderRow = () => {
    const staticColumns = ['POM Code', 'POM Description'];
    const totMInus = ['Tol (-/+)'];
    const sizeRanges = JSON.parse(specTemplateData?.sizeRanges);
    const dynamicColumns = sizeRanges?.map((range) => `${range.name}`);
    return [...staticColumns, ...dynamicColumns, ...totMInus];
  };

  // Helper function to format numbers with plus/minus signs for Excel export
  const formatNumberWithSign = (value) => {
    // Handle undefined, null, or empty string
    if (value === undefined || value === null || value === '') return '0';

    // Convert to string and trim
    const strValue = String(value).trim();

    // Check if the original value contains a plus or minus sign
    const hasSign = strValue.includes('+') || strValue.includes('-');

    // If no sign in original value, just return rounded number
    if (!hasSign) {
      const numericValue = Number(strValue);
      if (Number.isNaN(numericValue) || !Number.isFinite(numericValue)) {
        return strValue;
      }
      return round(numericValue, 3).toString();
    }

    // If value has a sign, format it accordingly
    const numericValue = Number(strValue);

    // If not a valid number, return as-is
    if (Number.isNaN(numericValue) || !Number.isFinite(numericValue)) {
      return strValue;
    }

    // Round the number to 3 decimal places
    const roundedValue = round(numericValue, 3);

    // Format based on sign: positive -> (+12), negative -> -12
    if (roundedValue > 0) {
      return `(+${roundedValue})`;
    }
    if (roundedValue < 0) {
      return roundedValue.toString();
    }
    return '0';
  };

  const getDataRows = () => {
    const sizeRanges = JSON.parse(specTemplateData?.sizeRanges);
    const rows = [];
    specTemplateData?.pomLibraries?.forEach((library) => {
      const staticValues = [library?.code, library?.description];
      const totMinus = [library?.tolMinus];
      const cloneGRading = library?.gradings?.filter((vl) => vl);
      const measurementValues = sizeRanges?.map((range) => {
        const grading = cloneGRading.find((item) => item?.sizeName === range?.name);
        return formatNumberWithSign(grading?.measurment);
      });
      const gradingValues = sizeRanges?.map((range) => {
        const grading = cloneGRading.find((item) => item?.sizeName === range?.name);
        return formatNumberWithSign(grading?.grading);
      });
      const staticGradValues = ['', ''];
      const totGradMinus = [''];
      rows.push([...staticValues, ...measurementValues, ...totMinus]);
      rows.push([...staticGradValues, ...gradingValues, ...totGradMinus]);
    });
    return rows;
  };

  const downloadExcelSheet = () => {
    const sizeRanges = JSON.parse(specTemplateData?.sizeRanges);

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([getMergedTitleRow(), getHeaderRow(), ...getDataRows()]);
    // Merge cells in title row
    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: (sizeRanges?.length || 0) + 2 } }];
    ws.A1 = { v: 'Spec Template Specifications', t: 's' };
    // Set the width of the first and second columns
    ws['!cols'] = [
      { wch: 30 }, // width of the first column
      { wch: 60 }, // width of the second column
    ];
    // Set all cells to left alignment
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = { c: C, r: R };
        const cell = ws[XLSX.utils.encode_cell(cellAddress)];
        if (cell && typeof cell === 'object' && !Array.isArray(cell)) {
          cell.s = { alignment: { horizontal: 'left' } };
        }
      }
    }

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), `${specTemplateData?.code}_${moment().unix()}.xlsx`);
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('SPEC_TEMP_LIBRARY.PAGE_TITLE')}</h4>
        </div>
        <div className="search-filter">
          {SpecAddEditAccess && isPageDisable ? (
            <button type="button" className="btn btn-white btn-back-lib " onClick={handleEditPage}>
              <i className="icon-edit mr-2" />
              {t('SPEC_TEMP_LIBRARY.EDIT')}
            </button>
          ) : (
            SpecAddEditAccess && (
              <button type="button" className="btn btn-white btn-back-lib " onClick={saveSpecTemplate} disabled={state?.loading}>
                <i className="icon-Save mr-2" />
                {t('SPEC_TEMP_LIBRARY.SAVE')}
              </button>
            )
          )}
          {checkArray(specTemplateData?.pomLibraries) && (
            <button type="button" className="btn btn-white btn-back-lib" onClick={() => downloadExcelSheet()}>
              {t('SPEC_TEMP_LIBRARY.EXPORT_EXCEL_SPEC')}
            </button>
          )}

          <Link className="btn btn-white btn-back-lib " to="/libraries/spec-template">
            {t('SPEC_TEMP_LIBRARY.BACK')}
          </Link>
        </div>
      </div>
      <Container fluid>
        {isPageLoad ? (
          <Loader />
        ) : (
          <>
            <Row className="my-4 position-relative">
              <div className={`${isPageDisable && 'disable-div'} custom-switch-on-off spec-template text-right`}>
                <BootstrapSwitchButton
                  checked={specTemplateData?.isPublished}
                  onlabel={t('SPEC_TEMP_LIBRARY.ACTIVE')}
                  offlabel={t('SPEC_TEMP_LIBRARY.INACTIVE')}
                  onChange={(e) => handleActiveInactive(e, 'isPublished')}
                />
              </div>

              <Col md={12}>
                <div className="spec-template-form">
                  <SpecImage
                    specTemplateData={specTemplateData}
                    isPageDisable={isPageDisable}
                    handleImageUpload={handleImageUpload}
                    handleImageDelete={handleImageDelete}
                    t={t}
                  />
                  <div className="flex-fill px-2 overflow-hidden">
                    <Row>
                      <Col md={3}>
                        <div className="common-input-control">
                          <p className="field-name">
                            {t('SPEC_TEMP_LIBRARY.SPEC_CODE')}
                            <span className="asterisk">*</span>
                          </p>
                          <input
                            type="text"
                            name="code"
                            disabled={isPageDisable}
                            onChange={(e) => handleInputSelect(e.target.value, 'code')}
                            onBlur={(e) => handleInputBlur(e.target.value, 'code')}
                            value={specTemplateData?.code || ''}
                            className="form-control"
                          />
                          {errorLog.includes('code') && <span className="error-message d-block">{t('SPEC_TEMP_LIBRARY.CODE_REQUIRED')}</span>}
                        </div>
                      </Col>
                      <Col md={7}>
                        <div className="common-input-control">
                          <p className="field-name">{t('SPEC_TEMP_LIBRARY.SPEC_DESC')}</p>
                          <input
                            type="text"
                            name="description"
                            disabled={isPageDisable}
                            maxLength={200}
                            onChange={(e) => handleInputSelect(e.target.value, 'description')}
                            onBlur={(e) => handleInputBlur(e.target.value, 'description')}
                            value={specTemplateData?.description || ''}
                            className="form-control"
                          />
                          <div className="text-count">{specTemplateData?.description?.length || 0}/200</div>
                        </div>
                      </Col>
                      <Col md={3}>
                        <div className="common-react-select">
                          <p className="field-name">
                            {t('SPEC_TEMP_LIBRARY.GRADING_GROUP')}
                            <span className="asterisk">*</span>
                          </p>
                          <Select
                            options={AllGradingList || []}
                            value={getSelectValue(AllGradingList, specTempGradingLib?._id) || null}
                            onChange={(e) => handleGradingChange(e)}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option._id}
                            className="common-select"
                            classNamePrefix="common-select"
                            placeholder={t('SPEC_TEMPLATE.ADD_EDIT_SPEC_TEMPLATE.GRADING_GROUP')}
                            isDisabled={isPageDisable}
                            isClearable
                            menuPosition="fixed"
                          />
                          {errorLog.includes('grading') && <span className="error-message d-block">{t('SPEC_TEMP_LIBRARY.GRADING_REQUIRED')}</span>}
                        </div>
                      </Col>

                      {isGradingChange && (
                        <GradingDetail
                          specTemplateData={specTemplateData}
                          handleSelect={handleInputSelect}
                          specTempGradingLib={specTempGradingLib}
                          getSelectValue={getSelectValue}
                          t={t}
                          isPageDisable={isPageDisable}
                          catBasedOnPTData={catBasedOnPTData}
                          setState={setState}
                          calculateMeasurement={calculateMeasurement}
                        />
                      )}
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
            {isEditMode && <SupportingDocument specTemplateId={specTemplateId} getSelectValue={getSelectValue} />}

            {isGradingChange && (
              <div className="d-flex my-2">
                <Typeahead
                  promptText={t('SPEC_TEMPLATE.ADD_EDIT_SPEC_TEMPLATE.NO_PRODUCT_FOUND')}
                  placeholder={t('SPEC_TEMPLATE.ADD_EDIT_SPEC_TEMPLATE.SEARCH_POM_LIBRARY')}
                  labelKey="code"
                  className="pom-serch-text"
                  filterBy={filterByLibrary}
                  options={pomLibraryOptions}
                  minLength={1}
                  disabled={!SpecAddEditAccess || isPageDisable || noPOMFound}
                  onChange={(selected) => onAutoSuggestion(selected)}
                  id="typeheadWithLibrary"
                  renderMenuItemChildren={(option) => (
                    <div className="d-flex" key={option?.code}>
                      <div className="list-text">
                        {option?.code}-{option?.description}
                      </div>
                    </div>
                  )}
                  ref={typeaheadPOM}
                />
                <button type="submit" disabled={isPageDisable || noPOMFound} className="btn btn-default px-3" onClick={handleImportPomGrading}>
                  {t('SPEC_TEMP_LIBRARY.BTN_IMPORT_GRADING')}
                </button>
                {SpecAddEditAccess && (
                  <button
                    type="button"
                    title={t('SPEC_TEMP_LIBRARY.REARRANGE_POM')}
                    className="btn btn-outline"
                    disabled={isPageDisable || !specTemplateId || (specTemplateData?.pomLibraries?.length || 0) < 2}
                    onClick={() => toggleRearrangeModal(true)}
                    aria-label={t('SPEC_TEMP_LIBRARY.REARRANGE_POM')}
                  >
                    <span className="icon icon-Rearrange" />
                  </button>
                )}
                {SpecDeleteAccess && (
                  <button
                    type="submit"
                    title="Delete"
                    className="btn btn-outline"
                    disabled={isPageDisable || noPOMFound}
                    onClick={() => deleteSinglePOM(selectedIdArray)}
                    aria-label="Delete"
                  >
                    <span className="icon icon-delete" />
                  </button>
                )}
              </div>
            )}
            {isGradingChange && (
              <POMTable
                specTemplateData={specTemplateData}
                specTempGradingLib={specTempGradingLib}
                handlePOMInput={handlePOMInput}
                handleTolIinput={handleTolIinput}
                calculateMeasurement={calculateMeasurement}
                isPageDisable={isPageDisable}
                t={t}
                deleteSinglePOM={deleteSinglePOM}
                onSelectCheckBox={onSelectCheckBox}
                SpecDeleteAccess={SpecDeleteAccess}
                selectedIdArray={selectedIdArray}
                handleCheckALl={handleCheckALl}
              />
            )}
          </>
        )}
      </Container>
      {showImageUpload && (
        <Modal className="common-custom-modal modal-large" show={showImageUpload} backdrop="static">
          <Modal.Header>
            <Modal.Title className="f-24">{t('SPEC_TEMP_LIBRARY.UPLOAD_IMAGE')}</Modal.Title>
            <span onClick={() => handleSubmitUpload('close')} className="icon-close cursor-pointer" />
          </Modal.Header>

          <Modal.Body>
            <div className="modal-body">
              <ImgDropzone
                ref={childRef}
                title={t('SPEC_TEMP_LIBRARY.PAGE_TITLE')}
                onSubmit={handleSubmitUpload}
                image={specTemplateData?.image}
                isEditMode={!isImageBase64}
                acceptedFileExtenstion=".jpeg,.png,.jpg"
              />
            </div>
          </Modal.Body>
        </Modal>
      )}
      {showDeleteModal && (
        <ConfirmationPopup
          onOpen={showDeleteModal}
          onConfirm={() => confirmDeleteImage()}
          title={t('SPEC_TEMP_LIBRARY.REMOVE_IMAGE')}
          message={t('SPEC_TEMP_LIBRARY.REMOVE_MESSAGE')}
          toggle={() => closeModal()}
        />
      )}
      {showConfirmImport && (
        <ConfirmationPopup
          onOpen={showConfirmImport}
          onConfirm={() => confirmImportPom()}
          title={t('SPEC_TEMP_LIBRARY.IMPORT_POM')}
          message={t('SPEC_TEMP_LIBRARY.IMPORT_POM_MESSAGE')}
          toggle={() => closeConfirmImportModal()}
        />
      )}
      {showRearrangeModal && (
        <DragDrogRearrange
          forSpecTemplate
          isShow={showRearrangeModal}
          isToggle={() => toggleRearrangeModal(false)}
          itemList={rearrangeItems}
          saveSequence={handleSaveRearrangeSequence}
        />
      )}
    </>
  );
}

export default AddEditSpecTemplate;
